<template>
  <common-card>
    <v-toolbar color="primary" dense dark flat>
      <v-toolbar-title>
        <span class="font-montserrat font-weight-bold"
          >Reporte de Solicitudes Alianzas</span
        >
      </v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-row>
        <v-col md="3">
          <v-select
            label="Seleccionar una Alianza"
            :items="alianzas"
            item-text="nombre"
            item-value="id"
            v-model="alianza"
            outlined
            class="mt-5"
          />

          <v-select
            label="Seleccionar tipo(s)"
            :items="tiposSolicitud"
            v-model="tiposSeleccionados"
            multiple
            outlined
            class="mt-4"
          />

          <v-radio-group v-model="modo" row>
            <v-radio label="Rango de fechas" value="rango" />
            <v-radio label="General" value="general" />
          </v-radio-group>

          <v-date-picker
            v-if="modo === 'rango'"
            v-model="dates"
            range
            :allowed-dates="validarFecha"
            locale="es"
          />

          <v-btn
            block
            color="primary"
            dark
            :loading="loading"
            :disabled="!puedeEjecutar"
            class="mt-4"
            @click="consultar"
          >
            Ejecutar
          </v-btn>

          <v-btn
            block
            class="mt-3"
            color="success"
            :disabled="reportDownload.length === 0"
            @click="descargarCSV"
          >
            Descargar
          </v-btn>
        </v-col>

        <v-col md="9">
          <v-data-table
            :headers="columns"
            :items="solicitudes"
            :loading="loading"
            loading-text="Consultando solicitudes..."
            no-data-text="No se encontraron solicitudes"
            :items-per-page="10"
            class="elevation-1"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </common-card>
</template>

<script>
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import moment from "moment";
import {
  consultarSolicitudesAlianzas,
  descargarSolicitudesAlianzasCSV,
} from "@/services/emision/emision.service.js";
import { getAlianzas } from "@/services/alianzas/alianzas.service.js";

export default {
  components: {
    CommonCard,
  },
  data() {
    return {
      alianza: null,
      alianzas: [],
      tiposSolicitud: ["Redención", "Siniestro"],
      tiposSeleccionados: [],
      modo: "rango",
      dates: [],
      solicitudes: [],
      reportDownload: [],
      loading: false,
      columns: [
        { text: "ID Solicitud", value: "id" },
        { text: "Fecha Registro", value: "fecha_creacion" },
        { text: "Estatus", value: "status" },
        { text: "Tipo", value: "tipo" },
        { text: "Categoría", value: "categoria" },
        { text: "Beneficio", value: "beneficioNombre" },
        { text: "Siniestro nombre", value: "siniestroNombre" },
        { text: "Socio", value: "num_socio" },
        { text: "Cliente", value: "cliente" },
        { text: "Fecha Cancelación", value: "fecha_cancelacion" },
      ],
    };
  },
  computed: {
    puedeEjecutar() {
      return (
        this.alianza &&
        this.tiposSeleccionados.length > 0 &&
        (this.modo === "general" ||
          (this.modo === "rango" &&
            this.dates.length === 2 &&
            this.validarFecha(this.dates[0])))
      );
    },
  },
  methods: {
    validarFecha(fecha) {
      const fechaLimite = moment()
        .subtract(2, "months")
        .startOf("day");
      return moment(fecha).isSameOrAfter(fechaLimite);
    },
    obtenerAlianzas() {
      getAlianzas()
        .then((data) => {
          this.alianzas = data || [];
        })
        .catch((err) => {
          this.alianzas = [];
          console.error("Error al obtener alianzas:", err);
          this.$toast.error("No se pudieron cargar las alianzas");
        });
    },

    async consultar() {
      const body = {
        alianzaId: String(this.alianza),
        tipos: this.tiposSeleccionados,
      };
      if (this.modo === "rango" && this.dates.length === 2) {
        const inicio = moment.utc(this.dates[0]).format("YYYY-MM-DD HH:mm:ss");
        const fin = moment
          .utc(this.dates[1])
          .add(24, "hours")
          .subtract(1, "seconds")
          .format("YYYY-MM-DD HH:mm:ss");
        body.fechaInicio = inicio;
        body.fechaFin = fin;
      }
      this.loading = true;
      try {
        this.solicitudes = [];
        this.reportDownload = [];
        const res = await consultarSolicitudesAlianzas(body);
        const solicitudes = Array.isArray(res) ? res : [];
        solicitudes.forEach((el) => {
          const registro = {
            id: el.solicitudId,
            fecha_creacion: el.fechaCreacion,
            status: el.statusTag || "No tiene",
            tipo: el.tipoPoliza,
            categoria: el.categoria,
            beneficio_asistencia: el.beneficio_asistencia,
            beneficioNombre: el.beneficioNombre || "No tiene",
            siniestroNombre: el.siniestroNombre || "No tiene",
            num_socio: el.num_socio,
            cliente: `${el.nombre || ""} ${el.apellidoPaterno ||
              ""} ${el.apellidoMaterno || ""}`.trim(),
            fecha_cancelacion: el.fechaCancelacion,
            motivo_cancelacion: el.motivoCancelacion,
          };
          this.solicitudes.push(registro);
          this.reportDownload.push(registro);
        });
      } catch (error) {
        this.solicitudes = [];
        this.reportDownload = [];
        console.error("Error al consultar solicitudes:", error);
        this.$toast.error("Ocurrió un error al consultar las solicitudes");
      } finally {
        this.loading = false;
      }
    },

    descargarCSV() {
      const body = {
        alianzaId: String(this.alianza),
        tipos: this.tiposSeleccionados,
      };
      if (this.modo === "rango" && this.dates.length === 2) {
        const inicio = moment.utc(this.dates[0]).format("YYYY-MM-DD HH:mm:ss");
        const fin = moment
          .utc(this.dates[1])
          .add(24, "hours")
          .subtract(1, "seconds")
          .format("YYYY-MM-DD HH:mm:ss");
        body.fechaInicio = inicio;
        body.fechaFin = fin;
      }
      descargarSolicitudesAlianzasCSV(body).then((res) => {
        const blob = new Blob([res], {
          type: "application/csv;charset=utf-8;",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Reporte_Solicitudes_Alianzas.csv");
        document.body.appendChild(link);
        link.click();
      });
    },
  },

  mounted() {
    this.obtenerAlianzas();
  },
};
</script>
